// extracted by mini-css-extract-plugin
export default {"resetButton":"S69zfjN","root":"gIT_w_f"};